<template>
  <div class="campaign-automation-group-info">
    <icons-sidebar-sub-account :width="19" :height="20" color="#62646A" />
    {{ contactsText }}
    <div class="campaign-automation-group-info__dot" />
    <template v-if="isPhysicalGift">
      <v-popover placement="top" trigger="hover" :container="false">
      <span class="campaign-automation-group-info__link">
        {{ addressesText }}
      </span>
        <template v-slot:popover>
          <group-info-tooltip :contacts="groupContacts" trigger="address" />
        </template>
      </v-popover>
    </template>
    <v-popover v-else placement="top" trigger="hover" :container="false">
      <span class="campaign-automation-group-info__link">
        {{ emailsText }}
      </span>
      <template v-slot:popover>
        <group-info-tooltip :contacts="groupContacts" trigger="email" />
      </template>
    </v-popover>
    <template v-if="trigger">
      <div class="campaign-automation-group-info__dot" />
      <v-popover placement="top" trigger="hover" :container="false">
        <span class="campaign-automation-group-info__link">
          {{ tooltipText }}
        </span>
        <template v-slot:popover>
          <group-info-tooltip :contacts="groupContacts" :trigger="selectedTrigger" />
        </template>
      </v-popover>
    </template>
  </div>
</template>

<script>
import GroupInfoTooltip from './AutomationCampaignPanelGroupInfoTooltip.vue';

export default {
  name: 'AutomationCampaignPanelGroupInfo',
  components: { GroupInfoTooltip },
  props: {
    group: {
      type: Object,
      required: true,
    },
    trigger: {
      type: String,
      required: false,
    },
    isPhysicalGift: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    groupContacts() {
      return this.group?.contacts ?? [];
    },
    contactsCount() {
      return this.group?.contacts_count ?? 0;
    },
    emailsCount() {
      return this.group?.emails_count ?? 0;
    },
    birthdayDateCount() {
      return this.group?.birthdays_count ?? 0;
    },
    anniversaryCount() {
      return this.group?.anniversaries_count ?? 0;
    },
    selectedTrigger() {
      return this.trigger || 'birthday';
    },
    fullAddressesCount() {
      return this.group?.full_addresses_count ?? 0;
    },
    tooltipText() {
      const { selectedTrigger, birthdayDateCount, anniversaryCount } = this;

      const isBirthday = selectedTrigger === 'birthday';
      const count = isBirthday ? birthdayDateCount : anniversaryCount;

      const label = isBirthday
        ? this.pluralize(count, 'birthday', 'birthdays')
        : this.pluralize(count, 'anniversary', 'anniversaries');

      return `${count} ${label} set`;
    },
    contactsText() {
      const count = this.contactsCount;

      return `${count} ${this.pluralize(count, 'Contact', 'Contacts')}`;
    },
    addressesText() {
      const count = this.fullAddressesCount;

      return `${count} ${this.pluralize(count, 'street address', 'street addresses')} set`;
    },
    emailsText() {
      const count = this.emailsCount;

      return `${count} ${this.pluralize(count, 'email', 'emails')} set`;
    },
  },
  methods: {
    pluralize(count, one, many) {
      return count === 1 ? one : many;
    },
  },
};
</script>

<style lang="scss" scoped>
.campaign-automation-group-info {
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: nowrap;
  white-space: nowrap;
  gap: 8px;

  & > b {
    font-family: 'Lato-Bold', sans-serif;
    font-weight: 700;
    font-size: 15px;
    line-height: 18px;
  }

  &__dot {
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background-color: #95979d;
  }

  &__link {
    color: #6e50ff;
    font-family: 'Lato-Regular', sans-serif;
    font-weight: 400;
    font-size: 15px;
    line-height: 18px;
    cursor: pointer;
  }
}
</style>
